import exportacao from '../resources/exportacoes';

function exportarFiltros(filtros, cb, contexto, nomeExportador, limit, timeout) {
  const resource = exportacao(contexto.$http, timeout);
  resource.download(nomeExportador,
    {
      limit,
      parametrosConsulta: filtros,
    })
    .then(() => {
      if (cb) {
        cb();
      }
      contexto.$toast.create(contexto.$t('message.exportacao_download'), 'snack', 3E3);
    })
    .catch(() => {
      if (cb) {
        cb();
      }
      contexto.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
    });
}

export default {
  exportar(cb, nomeExportador, contexto, parametros = {}, limit = 500, timeout = 120000) {
    exportarFiltros(parametros, cb, contexto, nomeExportador, limit, timeout);
  },
};



// WEBPACK FOOTER //
// ./src/common/functions/exportacao.js